const DOMESTIC_PREFIX = '中国 · ';

// The backend sends "国家 · 省份 · 城市 · 运营商". Most players are
// domestic, so the country is dropped there to keep the column narrow.
export function formatSourceLocation(location?: string | null): string {
  if (!location) return '';
  return location.startsWith(DOMESTIC_PREFIX) ? location.slice(DOMESTIC_PREFIX.length) : location;
}
